import { DTOgetOrderDetailedData } from 'types/orders';
import './OrderDestinationCountLabel.scss';

interface IOrderDestinationCountLabelProps {
  orderData?: DTOgetOrderDetailedData;
}

export const OrderDestinationCountLabel = ({ orderData }: IOrderDestinationCountLabelProps) => {
  const deliveryCountryFlag = Object.values(orderData?.listProducts ?? {})?.[0]?.flag;
  const numberOfDestinations =
    orderData?.generalData?.shipmentGroupsData != null
      ? orderData.generalData.shipmentGroupsData.length
      : 0;

  return (
    <div className="orderDestinationCountLabel">
      <p className="text">
        {numberOfDestinations} Destino
        {numberOfDestinations === 1 ? '' : 's'}
      </p>
      <div className="flag">
        {deliveryCountryFlag ? (
          <img className="img" src={deliveryCountryFlag} alt="delivery country flag" />
        ) : null}
      </div>
    </div>
  );
};
